import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class NotiService {

  private messageSource: BehaviorSubject<string> = new BehaviorSubject("th");
  public message = this.messageSource.asObservable();
  public langChange(_lang: string) {
    this.messageSource.next(_lang);
  }

}



// WEBPACK FOOTER //
// ./src/app/noti.service.ts